export default "__VITE_ASSET__CP3H6_WP__"